<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="ded" id="ded">for Billy Martin, with love—</p>
<p class="ded">remember Blackpool, Doc!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4ae4d975